const RETURN_URL_BASE = 'https://return-url.invalid'

function parseUrl(url: string, base?: string): URL | null {
  try {
    return new URL(url, base)
  }
  catch {
    return null
  }
}

const PRE_PRODUCTION_HOST_PREFIXES = ['acpt', 'test']

function getTrustedOrigins(domainUrl: string): string[] {
  const siteUrl = parseUrl(domainUrl)

  if (!siteUrl)
    return [RETURN_URL_BASE]

  return [
    RETURN_URL_BASE,
    siteUrl.origin,
    ...PRE_PRODUCTION_HOST_PREFIXES.map(prefix => `${siteUrl.protocol}//${prefix}.${siteUrl.host}`),
  ]
}

export function getReturnUrl(search: string, domainUrl: string): string | null {
  const searchParams = new URLSearchParams(search)
  const returnUrl = searchParams.get('returnUrl') || searchParams.get('returnurl')

  // eslint-disable-next-line no-control-regex -- This is needed for this special case to prevent control characters in the returnUrl
  if (!returnUrl || !/^(?:\/|https?:\/\/)/i.test(returnUrl) || /[\u0000-\u001F\u007F\\]/.test(returnUrl))
    return null

  const parsedUrl = parseUrl(returnUrl, RETURN_URL_BASE)

  return parsedUrl && getTrustedOrigins(domainUrl).includes(parsedUrl.origin) && !parsedUrl.pathname.startsWith('//')
    ? `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
    : null
}
